import {closeModal, openModal, pathIs, polishPlurals, url} from "../../../utilities";
import {toastAlert} from "../../../toastAlert";
import moment from "moment";
import {confirmModal} from "../../../confirmModal";
import Spinner from "../../../spinner";
import {
  generateSyncPopover,
  isAnimalItem,
  renderItemRow,
  renderItemRowBeforeCorrection,
  renderItemRowCorrectionSummary
} from "./invoice_items";
import * as Constants from "../constants";
import axios from "axios";
import {emptyForm, enableFormBack, fillFormInputs, handleApiForm, hideField, showField} from "../../../forms";
import {users_and_entities} from "./users_and_entities";
import {naturalSort} from "../../../datatables/dataTables.naturalSorting";
import dataLayer from "./data";
import FileDownload from "js-file-download";

const uuid = require('uuid/v4');

export const invoices_page = () => {
  if (pathIs(['/app/reckonings/invoices/add', '/app/reckonings/invoices/*/edit'])) {
    const body = $('body');
    const itemsTable = $('#itemsTable');

    const form = $('#addInvoice, #editInvoice, #addInvoiceCorrection, #editInvoiceCorrection');
    const isCorrecting = form.attr('id') === 'addInvoiceCorrection' || form.attr('id') === 'editInvoiceCorrection';
    const isCorrectionEditing = $('#editInvoiceCorrection').length > 0;

    let editing = false;
    if (form.attr('id') === 'editInvoice' || form.attr('id') === 'addInvoiceCorrection' || form.attr('id') === 'editInvoiceCorrection') {
      editing = true;
    }

    const typeNode = form.find("select[name='type']");
    const collectionCentreNode = form.find("select[name='collection_centre_id']")
    const priceListTypeNode = form.find('select[name="price_list_type"]');
    const userNode = form.find('select[name="user_id"]');

    const isRW = form.find('input[name="is_internal_expenditure"]');
    const RWLabel = document.getElementById('internal_expenditure_label');

    const isCD = form.find('input[name="is_carcass_disposal"]');

    if (isRW.val()) {
      RWLabel.textContent = 'Data rozchodu';
    }

    // Initialize data layer
    dataLayer.initialize();

    users_and_entities(onEntitiesDataUpdated);

    let oldType = parseInt(typeNode.val());
    let oldCollectionCentre = parseInt(collectionCentreNode.val());
    let oldPriceListType = parseInt(priceListTypeNode.val());
    let intendedUse = 0;
    let priceListType = priceListTypeNode.val();
    let userId = userNode.val();

    let updateAnimalQuantityAfterModalEdit = false;

    let userChanged = false;

    if (userId.startsWith('entity-')) {
      let entity = dataLayer.state.entities.find(el => parseInt(el.id) === parseInt(userId.replace('entity-', '')));
      if (entity) {
        dataLayer.setCurrentEntityId(entity.id);
      }
    }

    let table = $('#animalsTable').DataTable({
      stateSave: false,
      columnDefs: [
        {
          targets: Constants.ANIMALS_CHECKBOX_INDEX,
          data: null,
          render: function (data, type, row) {
            let input = $(`<input data-id="${row.id}" data-type="${row.type}" type="checkbox" class="form-check-input" name="animal[]"/>`);
            let span = $('<span class="input-wrapper"></span>').append(input);

            let can = canItemBeSelected(row);

            if (!can.result) {
              input.attr('disabled', true);
              span.prop('title', can.reason);
            }

            return span.prop('outerHTML');
          }
        },
        {
          targets: Constants.ANIMALS_NAME_INDEX,
          data: 'name',
        },
        {
          targets: Constants.ANIMALS_NAME_INDEX,
          data: 'name',
        },
        {
          targets: Constants.ANIMALS_QUANTITY_INDEX,
          data: 'quantity',
        },
        {
          targets: Constants.ANIMALS_DATE_INDEX,
          data: 'date',
          render: (data) => {
            return moment(data, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY');
          }
        },
        {
          targets: Constants.ANIMALS_HUNTER_INDEX,
          data: 'hunter',
        },
        {
          targets: Constants.ANIMALS_COLLECTION_CENTRE_INDEX,
          data: 'collection_centre',
          render: (data, type, row) => {
            if (data === null) {
              return '-';
            }

            return `<span data-collection_centre_id="${row.collection_centre_id}">${data}</span>`;
          }
        },
        {
          targets: Constants.ANIMALS_NUMBER_MP_INDEX,
          data: 'number_mp',
          defaultContent: '-'
        },
        {
          targets: Constants.ANIMALS_DISTRICT_INDEX,
          data: 'district',
        },
        {
          targets: Constants.ANIMALS_WEIGHT_INDEX,
          data: 'weight',
        },
        {
          targets: Constants.ANIMALS_IDENTIFIER_INDEX,
          data: 'identifier',
          render: (data) => {
            return (data && data.length) > 0 ? data : '-';
          }
        },
        {
          targets: Constants.ANIMALS_IDENTIFIER_DISTRICT_VETERINARIAN_INDEX,
          data: 'identifier_district_veterinarian',
          render: (data) => {
            return (data && data.length) > 0 ? data : '-';
          }
        },
        {
          targets: Constants.ANIMALS_IDENTIFIER_DIRECT_SALE_INDEX,
          data: 'identifier_direct_sale',
          render: (data) => {
            return (data && data.length) > 0 ? data : '-';
          }
        },
        {
          targets: Constants.ANIMALS_ACTIONS_INDEX,
          data: null,
          render: (data, type, row) => {
            return `
                            <button class="btn btn-sm btn-primary btnEditAnimal" data-id="${row.id}" data-type="${row.type}" type="button">Edytuj</button>
                        `;
          }
        }
      ],
      drawCallback: function () {
        let inputs = this.$('span.input-wrapper');
        inputs.each(function () {
          new bootstrap.Tooltip(this)
        })
      }
    })
    $("#addItems").on('shown.bs.modal', function () {
      table.api().columns.adjust().responsive.recalc()
    })

    function handleCollectionCentreChange() {
      let id = collectionCentreNode.val();
      let text = null;

      if (parseInt(id) !== 0) {
        text = collectionCentreNode.find(`option[value="${id}"]`).text().trim();
      }

      table.api().column(Constants.ANIMALS_COLLECTION_CENTRE_INDEX).search(text ? '^' + text + '|-$' : '', true, false).draw(false);
    }

    function reloadAnimalsTable() {
      let type = typeNode.val();
      if (parseInt(type) === 1 || parseInt(type) === 3) {
        form.find('select[name="user_id"]').closest('.col-12').show();
      } else {
        form.find('select[name="user_id"]').closest('.col-12').hide();
      }

      if (parseInt(type) === 2) {
        collectionCentreNode.closest('.col-12').show();
        table.api().column(Constants.ANIMALS_COLLECTION_CENTRE_INDEX).visible(true);
        table.api().column(Constants.ANIMALS_NUMBER_MP_INDEX).visible(true);
      } else {
        collectionCentreNode.closest('.col-12').hide();
        table.api().column(Constants.ANIMALS_COLLECTION_CENTRE_INDEX).visible(false);
        table.api().column(Constants.ANIMALS_NUMBER_MP_INDEX).visible(false);
      }

      intendedUse = typeToIntendedUse(type);
      table.api().columns().search('');
      table.api().clear().rows.add(dataLayer.availableAnimals.filter(el => parseInt(el.intended_use) === parseInt(intendedUse))).draw();

      if (parseInt(type) === 2) {
        handleCollectionCentreChange();
      }
    }

    reloadAnimalsTable();

    typeNode.change(async function () {
      let type = parseInt($(this).val());

      let result = true;
      if (dataLayer.state.invoiceItems.length > 0) {
        if (type === 2 || (oldType === 2)) {
          let filteredItems = dataLayer.state.invoiceItems.filter(i => i.type === Constants.ITEM_TYPE_ITEM);

          if (filteredItems.length !== dataLayer.state.invoiceItems.length) {
            if (filteredItems.length === 0) {
              result = await confirmModal('Zmiana na ten rodzaj spowoduje usunięcie wszystkich wybranych pozycji. Czy jesteś pewny/a, że chcesz kontynuować?');
            } else {
              result = await confirmModal('Zmiana na ten rodzaj spowoduje usunięcie niektórych wybranych pozycji. Czy jesteś pewny/a, że chcesz kontynuować?');
            }

            if (result) {
              dataLayer.state.invoiceItems = filteredItems;
              reloadItemsTable();
            }
          }
        }
      }

      if (result) {
        oldType = parseInt($(this).val());
        reloadAnimalsTable();
      } else {
        $(this).val(oldType);
      }
    })

    collectionCentreNode.change(async function () {
      let collectionCentre = parseInt($(this).val());

      let result = true;
      if (dataLayer.state.invoiceItems.length > 0) {
        if (collectionCentre !== 0 && collectionCentre !== oldCollectionCentre) {
          let itemsFromDifferentCollectionCentre = dataLayer.state.invoiceItems.filter(r => parseInt(r.collection_centre_id) !== collectionCentre && r.collection_centre_id);

          if (itemsFromDifferentCollectionCentre.length > 0) {
            result = await confirmModal('Zmiana miejsca skupu spowoduje usunięcie niektórych wybranych pozycji. Czy jesteś pewny/a, że chcesz kontynuować?');
            if (result) {
              dataLayer.state.invoiceItems = dataLayer.state.invoiceItems.filter(r => !r.collection_centre_id);
              reloadItemsTable();
              reloadAnimalsTable();
            }
          }
        }
      }

      if (result) {
        oldCollectionCentre = collectionCentre;
        handleCollectionCentreChange();
      } else {
        $(this).val(oldCollectionCentre);
      }

      let checked = table.api().checkedCheckboxes();
      for (let input of checked) {
        input = $(input);

        let row = input.closest('tr');
        let collection_centre_id = row.find('[data-collection_centre_id]').data('collection_centre_id');

        if (collection_centre_id && parseInt(collectionCentreNode.val()) !== parseInt(collection_centre_id)) {
          input.prop('checked', false);
        }
      }

    })

    function typeToIntendedUse(type) {
      let result = 0;

      switch (parseInt(type)) {
        case 1:
          result = 6
          break;
        case 2:
          result = 1;
          break;
        case 3:
          result = 2
          break;
        case 4:
          result = 3
          break;
      }

      return result;
    }

    let intendedUseNames = [];
    typeNode.find('option').each(function () {
      intendedUseNames[$(this).val()] = $(this).text();
    })

    function updateCarcassesLeft() {
      typeNode.find('option').each(function () {
        let type = $(this).val()
        let intendedUse = typeToIntendedUse(type);

        let carcassesLeft = dataLayer.availableAnimals.filter(el => parseInt(el.intended_use) === parseInt(intendedUse)).length;
        if (carcassesLeft > 0) {
          $(this).text(intendedUseNames[$(this).val()] + ` (${carcassesLeft} ${polishPlurals('tusza', 'tusze', 'tusz', carcassesLeft)} do rozliczenia)`)
        }
      })
    }

    updateCarcassesLeft();

    function handleQualityClassVisibility() {
      const index = itemsTable.find('[data-app-column="quality"]').index()+1;

      if (parseInt(priceListTypeNode.val()) === Constants.PRICE_LIST_FLAT_RATE) {
        $(`td:nth-child(${index}), th:nth-child(${index})`).hide();
      } else {
        $(`td:nth-child(${index}), th:nth-child(${index})`).show();
      }

    }

    priceListTypeNode.change(async function () {
      priceListType = parseInt($(this).val());

      let result = true;
      if (dataLayer.state.invoiceItems.length > 0) {
        if (priceListType !== oldPriceListType) {
          let disabledItems = dataLayer.state.invoiceItems.filter(r => !r.fitsRequirements(intendedUse, priceListType));
          if (disabledItems.length > 0) {
            result = await confirmModal('Zmiana rodzaju cennika spowoduje usunięcie niektórych wybranych pozycji. Czy jesteś pewny/a, że chcesz kontynuować?');
            if (result) {
              dataLayer.state.invoiceItems = dataLayer.state.invoiceItems.filter(r => disabledItems.findIndex(d => parseInt(d.id) === parseInt(r.id) && d.type === r.type) === -1);
            }
          }
        }
      }

      if (result) {
        oldPriceListType = priceListType;
        reloadAnimalsTable();
        reloadItemsTable();
        handleQualityClassVisibility();
      } else {
        $(this).val(oldPriceListType);
      }
    })

    body.on('change', 'input[name="animal[]"]', function () {
      let row = $(this).closest('tr');

      if (parseInt(intendedUse) === 1 && $(this).prop('checked')) {
        let collection_centre_id = row.find('[data-collection_centre_id]').data('collection_centre_id');

        if (collection_centre_id && parseInt(collection_centre_id) !== parseInt(collectionCentreNode.val())) {
          collectionCentreNode.val(collection_centre_id).change();
          let collectionCentreOption = collectionCentreNode.find(`option[value="${collection_centre_id}"]`);

          toastAlert(`Zmieniono miejsce skupu na "${collectionCentreOption.text().trim()}". Kolejność pozycji w tabeli mogły ulec zmianie.`)
        }
      }
    })

    // Items table
    let itemsChosen = JSON.parse(window._itemsChosen ?? '[]');

    if (itemsChosen.length > 0) {
      for (let chosen of itemsChosen) {
        dataLayer.addInvoiceItem(chosen);
      }
    }

    reloadItemsTable()
    reloadAnimalsTable()
    handleQualityClassVisibility();

    function reloadItemsTable() {
      const tbody = itemsTable.find('tbody')

      $('.popover').remove();
      tbody.empty()

      if(dataLayer.state.invoiceItems.length === 0) {
        tbody.append(`
          <tr>
            <td colspan="8" class="text-center">
                brak pozycji
            </td>
          </tr>
        `)
      }

      // render all rows based on items
      for(const item of dataLayer.state.invoiceItems.sort((a, b) => a.no - b.no)) {
        item.autoSetQualityChosen(intendedUse)

        if(isCorrecting) {
          tbody.append(renderItemRowBeforeCorrection(form, intendedUse, priceListType, item))
        }

        tbody.append(renderItemRow(form, intendedUse, priceListType, item))

        if(isCorrecting) {
          tbody.append(renderItemRowCorrectionSummary(form, intendedUse, priceListType, item))
        }

        generateSyncPopover(form, priceListType, intendedUse, item)
      }

      // hide VAT if has no items
      const vatIndex = $('[data-app-column="vat"]').index()+1;

      if(dataLayer.state.invoiceItems.filter(i => !i.isAnimal).length) {
        itemsTable.find(`td:nth-child(${vatIndex}), th:nth-child(${vatIndex})`).show();
      } else {
        itemsTable.find(`td:nth-child(${vatIndex}), th:nth-child(${vatIndex})`).hide();
      }

      // initialize tooltips
      itemsTable.find('[data-bs-toggle="tooltip"]').each(function() {
        new bootstrap.Tooltip(this)
      })

      handleQualityClassVisibility()
    }

    $("#btnAddItems").click(function () {
      let checked = table.api().checkedCheckboxes();
      let element;

      for (let input of checked) {
        input = $(input);

        let id = parseInt(input.data('id'));
        let type = input.data('type');

        element = dataLayer.state.animals.find(el => parseInt(el.id) === id && el.type === type);
        if (element) {
          if(isCD.val() && (!element.price_beyond)){
            element.quality = 0;
            element.price_beyond = 0;
          }
          dataLayer.addInvoiceItem({...element, no: dataLayer.state.invoiceItems.filter(i => !i.isAfterCorrection).length + 1});
        }
      }

      if (parseInt(typeNode.val()) === 3 && !editing && !userChanged && element) {
        if (element.hunter_id && element.hunter_id !== '') {
          userNode.val(element.hunter_id);
          toastAlert(`Zmieniono nabywcę na ${element.hunter.trim()}.`)
        }
      }

      closeModal($(this).closest('.modal'));
      reloadAnimalsTable();
      reloadItemsTable();
    })

    $('[name="is_items_correction"]').on('change', function() {
      const checked = $(this).prop('checked');
      const container = $('#itemsTable').closest('.box')

      if(checked) {
        container.show()
      } else {
        container.hide()
      }
    }).trigger('change')

    body.on('click', '.btnDeleteItem', async function () {
      const id = parseInt($(this).data('id'));
      const type = $(this).attr('data-type');
      const uuid = $(this).data('uuid');
      const item = dataLayer.state.invoiceItems.find(i => uuid ? i.uuid === uuid : (i.id === id && i.type === type));

      if(!item) {
        return
      }

      const directDeletion = !isCorrecting || !item.isStored || (isCorrectionEditing && !item.parent)

      if (await confirmModal(`Czy na pewno chcesz usunąć tą pozycję z faktury? ${!directDeletion ? 'Ilość zostana ustawiona na "0".' : ''}`, {color: 'danger'})) {

        if(!directDeletion) {
          item.quantity = 0;
        } else {
          dataLayer.removeInvoiceItem(id, type, uuid);
          dataLayer.resetInvoiceItemsNo();
        }

        reloadItemsTable();
        reloadAnimalsTable();
      }
    })

    body.on('click', '[data-app-action="load_seller_data"], [data-app-action="load_buyer_data"]', async function() {
      const actionType = $(this).attr('data-app-action');

      let type = null;
      let id = null;

      const typeNodeValue = parseInt(typeNode.val())

      if(actionType === 'load_seller_data') {
        type = 'app\\models\\Association'
      } else {
        if(typeNodeValue === 1 || typeNodeValue === 3) {
          const userNodeValue = userNode.val()

          if(userNodeValue.startsWith('entity-')) {
            type = 'app\\models\\BusinessEntity'
            id = userNodeValue.replace('entity-', '')
          } else {
            type = 'app\\models\\User'
            id = userNodeValue
          }
        } else if(typeNodeValue === 2) {
          type = 'app\\models\\CollectionCentre'
          id = collectionCentreNode.val()
        } else {
          type = 'app\\models\\Association'
        }
      }

      const spinner = new Spinner()

      try {
        let text = null

        if((typeNodeValue === 1 || typeNodeValue === 3) && parseInt(id) === 0) {
          const name = `${$('[name="guest_first_name"]').val()} ${$('[name="guest_last_name"]').val()}`
          const addressLine1 = $('[name="guest_address_line_1"]').val()
          const addressLine2 = $('[name="guest_address_line_2"]').val()
          const city = $('[name="guest_city"]').val()
          const postalCode = $('[name="guest_postal_code"]').val()

          let address = `${addressLine1 ?? ''} ${addressLine2 ?? ''}, ${postalCode ?? ''} ${city ?? ''}`

          text = `${name}\n${address}`
        } else {
          const response = await axios.get('/api/reckonings/invoices/get-party-details?type=' + type + '&id=' + id)
          if (response.data) {
            const data = response.data.data

            if (data) {
              text = `${data.name}\n${data.address}${data.tax_number ? '\nNIP: ' + data.tax_number : ''}${data.account_number ? '\nNr konta: ' + data.account_number : ''}`
            }
          }
        }

        if(text) {
          $(this).closest('div').find('textarea').val(text)
          toastAlert('Wczytano dane z systemu')
          return
        }
      } catch(err) {
        console.log(err)
      } finally {
        spinner.destroy()
      }

      toastAlert('Nie udało się wczytać danych z systemu', {type: 'warning'})
    })

    function getPrices(item) {
      if (isAnimalItem(item)) {
        if (parseInt(intendedUse) === 1) {
          let collectionCentre = dataLayer.state.collectionCentres.find(c => parseInt(c.id) === parseInt(item.collection_centre_id));

          if (!collectionCentre) {
            return {
              price_1_class: null,
              price_2_class: null,
              price_beyond: null,
              flat_rate: null,
            }
          }

          let prices = collectionCentre.cc_prices.find(p => parseInt(p.animal_type_id) === parseInt(item.animal_type_id));
          let ex_prices = '';

          if (prices) {
            ex_prices = prices.animal_cc_prices.find(p => parseInt(p.animal_id) === parseInt(item.animal_id));

            if (ex_prices) {
              prices.ex_price_1_class = ex_prices.price_1_class;
              prices.ex_price_2_class = ex_prices.price_2_class;
              prices.ex_price_beyond = ex_prices.price_beyond;
              prices.ex_flat_rate = ex_prices.flat_rate;
            } else {
              prices.ex_price_1_class = null;
              prices.ex_price_2_class = null;
              prices.ex_price_beyond = null;
              prices.ex_flat_rate = null;
            }

          }

          return {
            price_1_class: prices ? (prices.ex_price_1_class ? prices.ex_price_1_class : prices.price_1_class) : null,
            price_2_class: prices ? (prices.ex_price_2_class ? prices.ex_price_2_class : prices.price_2_class) : null,
            price_beyond: prices ? (prices.ex_price_beyond ? prices.ex_price_beyond : prices.price_beyond) : null,
            flat_rate: prices ? (prices.ex_flat_rate ? prices.ex_flat_rate : prices.flat_rate) : null
          };
        }

        if (dataLayer.currentEntity !== null) {
          let prices = dataLayer.currentEntity.be_prices.find(el => parseInt(el.animal_type_id) === parseInt(item.animal_type_id));
          let ex_prices = '';

          if (prices) {
            ex_prices = prices.animal_be_prices.find(p => parseInt(p.animal_id) === parseInt(item.animal_id));

            if (ex_prices) {
              prices.ex_price_1_class = ex_prices.price_1_class;
              prices.ex_price_2_class = ex_prices.price_2_class;
              prices.ex_price_beyond = ex_prices.price_beyond;
              prices.ex_flat_rate = ex_prices.flat_rate;
            } else {
              prices.ex_price_1_class = null;
              prices.ex_price_2_class = null;
              prices.ex_price_beyond = null;
              prices.ex_flat_rate = null;
            }
          }

          return {
            price_1_class: prices ? (prices.ex_price_1_class ? prices.ex_price_1_class : prices.price_1_class) : null,
            price_2_class: prices ? (prices.ex_price_2_class ? prices.ex_price_2_class : prices.price_2_class) : null,
            price_beyond: prices ? (prices.ex_price_beyond ? prices.ex_price_beyond : prices.price_beyond) : null,
            flat_rate: prices ? (prices.ex_flat_rate ? prices.ex_flat_rate : prices.flat_rate) : null
          }
        }

        return {
          price_1_class: item.ex_price_1_class ?? item.price_1_class,
          price_2_class: item.ex_price_2_class ?? item.price_2_class,
          price_beyond: item.ex_price_beyond ?? item.price_beyond,
          flat_rate: item.ex_flat_rate ?? item.flat_rate
        }
      } else {
        return {
          price_1_class: item.getNettoForItems(),
          price_2_class: item.getNettoForItems(),
          price_beyond: item.getNettoForItems(),
          flat_rate: item.getNettoForItems(),
        };
      }
    }

    function canItemBeSelected(item, _priceListType = priceListType) {
      let result = true;
      let reason = '';

      if (!isAnimalItem(item)) {
        return {result: true, reason: ''};
      }

      if (parseInt(_priceListType) === Constants.PRICE_LIST_REGULAR) {
        if (parseInt(item.is_big) === 1 && (parseFloat(item.weight) === 0 || !item.weight)) {
          result = false;
          reason = 'zwierzyna nie posiada wprowadzonej wagi'
        }

        if (!getPrices(item).price_1_class && !getPrices(item).price_2_class && !getPrices(item).price_beyond) {
          if(!isCD.val()){
            result = false;
            reason = 'gatunek nie ma ustalonej ceny w żadnej z klas jakości'
          }
        }
      } else if (parseInt(_priceListType) === Constants.PRICE_LIST_FLAT_RATE) {
        const price = getPrices(item).flat_rate;

        if (!price || parseFloat(price) === 0) {
          result = false;
          reason = 'gatunek nie ma ustalonej ceny ryczałtowej'
        }
      }

      return {result, reason};
    }

    // todo delete
    window.data = dataLayer.state;

    const addOrUpdateInput = (form, name, value) => {
      let input = $(`input[name="${name}"]`);
      if(!input.length) {
        input = $(`<input type="hidden" name="${name}" />`);
        $(form).append(input);
      }

      input.val(value)
    }

    form.submit(function (e) {
      e.preventDefault();

      let i = 0;
      for (let item of dataLayer.state.invoiceItems) {
        addOrUpdateInput(this, `items[${i}][id]`, item.id)
        addOrUpdateInput(this, `items[${i}][no]`, item.no)
        addOrUpdateInput(this, `items[${i}][type]`, item.type)
        addOrUpdateInput(this, `items[${i}][quantity]`, item.quantity)
        addOrUpdateInput(this, `items[${i}][price_type]`, item.price_type)

        if (typeof item.invoice_item_id != 'undefined') {
          addOrUpdateInput(this, `items[${i}][invoice_item_id]`, item.invoice_item_id)
        }

        const prices = item.getPrices(intendedUse)
        addOrUpdateInput(this, `items[${i}][price_1_class]`, prices.price_1_class)
        addOrUpdateInput(this, `items[${i}][price_2_class]`, prices.price_2_class)
        addOrUpdateInput(this, `items[${i}][price_beyond]`, prices.price_beyond)
        addOrUpdateInput(this, `items[${i}][flat_rate]`, prices.flat_rate)
        addOrUpdateInput(this, `items[${i}][price_netto]`, item.price_netto)
        addOrUpdateInput(this, `items[${i}][price_brutto]`, item.price_brutto)

        if (item.isAnimal) {
          addOrUpdateInput(this, `items[${i}][quality]`, item.quality)
          addOrUpdateInput(this, `items[${i}][weight]`, item.weight)
        } else {
          addOrUpdateInput(this, `items[${i}][uuid]`, item.uuid)
          addOrUpdateInput(this, `items[${i}][currency]`, item.currency)
          addOrUpdateInput(this, `items[${i}][vat]`, item.getVat(form))
          addOrUpdateInput(this, `items[${i}][unit]`, item.getUnit(priceListType))
        }

        i++;
      }

      this.submit();
    })

    // Ustawianie domyślnych wartości przy zmianie miejsca skupu
    let btnSetPriceListSettingsBasedOnDefault = $("#btnSetPriceListSettingsBasedOnDefault");

    btnSetPriceListSettingsBasedOnDefault.click(function () {
      if (parseInt(typeNode.val()) === 2) {
        let collectionCentre = dataLayer.state.collectionCentres.find(c => parseInt(c.id) === parseInt(collectionCentreNode.val()));
        if (collectionCentre) {
          $('input[name="maturity"]').val(collectionCentre.maturity);
          $('input[name="vat"]').val(collectionCentre.vat);
          priceListTypeNode.val(collectionCentre.price_list_type).change();
        }
      } else if (dataLayer.currentEntity !== null) {
        $('input[name="maturity"]').val(dataLayer.currentEntity.maturity);
        $('input[name="vat"]').val(dataLayer.currentEntity.vat ? dataLayer.currentEntity.vat : null);
        priceListTypeNode.val(dataLayer.currentEntity.price_list_type).change();
      } else {
        $('input[name="maturity"]').val(defaultMaturity);
        $('input[name="vat"]').val(defaultVAT ? defaultVAT.toFixed(2) : null);
        priceListTypeNode.val(defaultPriceListType).change();
      }
    })

    body.on('change', '[name="vat"]', function() {
      if($('select[name="calculation_method"]').val() == 1){
        $('input[name="vat"]').val(0);
      }
      reloadItemsTable();
    })

    body.on('change', '[name="calculation_method"]', function() {
      if($('select[name="calculation_method"]').val() == 1){
        $('input[name="vat"]').val(0);
      }
      reloadItemsTable();
    })

    body.on('change', 'select[name="quality"]', function () {
      let id = $(this).data('id');
      let type = $(this).data('type');

      const invoiceItem = dataLayer.state.invoiceItems.find(el => parseInt(el.id) === id && el.type === type);
      if (invoiceItem) {
        invoiceItem.quality = parseInt($(this).val());
      }

      reloadItemsTable()
    })

    body.on('click', function(e) {
      const popoverElement = $('.popover, [data-app-popover="sync"]'); // Popover i trigger

      // Sprawdź, czy kliknięcie było poza popoverem lub triggerem
      if (!popoverElement.is(e.target) && popoverElement.has(e.target).length === 0) {
        // Kliknięcie poza wskazanymi elementami - ukryj popover
        $('[data-app-popover="sync"]').popover('hide');
      }

    })

    $('[name="is_seller_correction"], [name="is_buyer_correction"], [name="is_other_correction"]').on('change', function() {
      const container = $(this).closest('.row');
      const textareas = container.find('textarea').closest('.row').closest('.col-12');

      if($(this).is(':checked')) {
        textareas.show();
      } else {
        textareas.hide();
      }
    }).trigger('change')

    // Items_item table
    let itemsItemTable = $("#items_itemTable").DataTable();

    $("#items_itemTable").on('draw.dt', function () {
      handleDifferentCurrencyInputs()
    });

    $("#addItems_item").on('shown.bs.modal', function () {
      itemsItemTable.api().columns.adjust().responsive.recalc();
      itemsItemTable.trigger('draw.dt');
    });

    function handleDifferentCurrencyInputs() {
      let currentCurrency = null;
      if (dataLayer.state.invoiceItems.length) {
        currentCurrency = dataLayer.state.invoiceItems[0].currency ?? 1
      }

      const table = $("#items_itemTable").DataTable()

      if (!currentCurrency) {
        table.$('input').each(function () {
          if ($(this).val() !== '' && Number($(this).val()) !== 0) {
            currentCurrency = $(this).closest('tr').find('.item__price').attr('data-currency');
          }
        })
      }

      if (!currentCurrency) {
        table.$('[name="quantity"]').attr('disabled', false)
        $('[data-app-item-errors]').text('')
        return
      }

      table.$('[name="quantity"]').attr('disabled', true)
      table.$(`[data-currency="${currentCurrency}"]`).closest('tr').find('[name="quantity"]').attr('disabled', false)

      $('[data-app-item-errors]').text('')

      for (const item of dataLayer.state.invoiceItems) {
        if ((parseInt(item.currency ?? '1')) !== parseInt(currentCurrency)) {
          $('[data-app-item-errors]').text('Na fakturze są pozycje z różnymi walutami!')
        }
      }
    }

    // function preventDifferentCurrencyItems(idValue) {
    //
    //   $("#items_itemTable tbody tr").each(function (index, row) {
    //
    //     if ($(row).find(".item__price").attr('id') != idValue) {
    //       $(row).find('input[name="quantity"]').prop('disabled', true);
    //     }
    //   });
    //
    // }

    // function allowDifferentCurrencyItems() {
    //
    //   $("#items_itemTable tbody tr").each(function (index, row) {
    //     $(row).find('input[name="quantity"]').prop('disabled', false);
    //   });
    // }

    body.on('change', '#addItems_item input[name="quantity"]', function () {
      let row = $(this).closest('tr');
      if (row.hasClass('child')) {
        row = row.prev('tr');
      }

      if (!row.hasClass('fw-bold') && $(this).val().length !== 0) {
        row.addClass('fw-bold');
      }

      if (row.hasClass('fw-bold') && $(this).val().length === 0) {
        row.removeClass('fw-bold');
      }

      handleDifferentCurrencyInputs()
    })

    $("#btnAddItems_items").click(function () {
      let inputs = itemsItemTable.$('input[name="quantity"]');

      for (let input of inputs) {
        input = $(input);
        let value = input.val();

        if (value === '' || parseFloat(value) === 0) {
          continue;
        }

        let id = parseInt(input.data('id'));

        let itemFound = dataLayer.state.items.find(el => parseInt(el.id) === id);
        if (itemFound) {
          dataLayer.addInvoiceItem({
            ...itemFound,
            quantity: parseFloat(value),
            no: dataLayer.state.invoiceItems.filter(i => !i.isAfterCorrection).length + 1,
            uuid: uuid()
          })
        }
      }

      closeModal($(this).closest('.modal'));
      reloadItemsTable();

      for (let input of inputs) {
        input = $(input);
        input.val('').change();
      }
    })

    body.on('click', '[data-app-update="unit"]', function() {
      const uniqueId = $(this).attr('data-app-unique_id');
      const item = dataLayer.getInvoiceItem(uniqueId)

      if(item) {
        item.unit = item.details.unit
        reloadItemsTable()
      }
    })

    body.on('click', '[data-app-update="quantity"]', function() {
      const uniqueId = $(this).attr('data-app-unique_id');
      const item = dataLayer.getInvoiceItem(uniqueId)

      if(item) {
        item.quantity = item.details.quantity
        item.weight = item.details.weight
        reloadItemsTable()
      }
    })

    body.on('click', '[data-app-update="vat"]', function() {
      const uniqueId = $(this).attr('data-app-unique_id');
      const item = dataLayer.getInvoiceItem(uniqueId)

      if(item) {
        item.vat = item.details.vat
        reloadItemsTable()
      }
    })

    body.on('click', '[data-app-update="price"]', function () {
      const uniqueId = $(this).attr('data-app-unique_id');
      const item = dataLayer.getInvoiceItem(uniqueId)

      if (item) {
        item.resetPrices(intendedUse)
        if(!item.isAnimal) {
          item.currency = item.details.currency
        }
        reloadItemsTable()
      }
    })

    body.on('click', '[data-app-update="currency"]', function () {
      const uniqueId = $(this).attr('data-app-unique_id');
      const item = dataLayer.getInvoiceItem(uniqueId)

      if (item && !item.isAnimal) {
        item.currency = item.details.currency
        reloadItemsTable()
      }
    })

    // Dodawanie nowego artykułu
    handleApiForm($('form#addItem'), ({response, form}) => {
      let item = response.data.item;
      dataLayer.addItem(item)

      let row = $(`
                <tr data-id="${item.id}">
                    <td class="item__name">${item.name}</td>
                    <td class="item__unit">${item.unit}</td>
                    <td class="item__price" data-currency="${item.currency}">${item.price}</td>
                    <td class="item__price_brutto">${item.price}</td>
                    <td class="item__vat">${item.vat ?? ''}</td>
                    <td class="item__code">${item.code ?? ''}</td>
                    <td>
                        <input data-id="${item.id}" data-type="${item.type}" type="number"
                               name="quantity" min="1" class="form-control form-control-sm"/>
                    </td>
                    <td>
                        <button class="btn btn-sm btn-primary btnEditItemsItem" type="button" data-id="${item.id}">
                            Edytuj
                        </button>
                    </td>
                </tr>
            `)

      itemsItemTable.api().rows.add(row).draw(false);

      closeModal($('form#addItem').closest('.modal'));
      emptyForm(form);

      handleDifferentCurrencyInputs()
      toastAlert('Pomyślnie dodano artykuł');
    })

    // Edytowanie artykułów
    body.on('click', '.btnEditItemsItem', function () {
      let form = $('#editItem');
      let id = $(this).data('id');

      let item = dataLayer.state.items.find(i => parseInt(i.id) === parseInt(id));
      form.attr('action', url(`api/reckonings/items/${id}/edit`));

      emptyForm(form);
      fillFormInputs(form, item);
      openModal($("#editItemModal"));
    })

    handleApiForm($('form#editItem'), ({response, form}) => {
      let newItemData = response.data.item;
      dataLayer.updateItem(newItemData, i => parseInt(i.id) === parseInt(newItemData.id))

      let row = itemsItemTable.$(`tr[data-id="${newItemData.id}"]`);
      let rowIndex = itemsItemTable.api().row(row).index();

      let curr = '';
      if (newItemData.currency == 2) {
        curr = 'Euro';
      } else {
        curr = "PLN";
      }

      itemsItemTable.api().cell(rowIndex, Constants.ITEMS_ITEM_NAME_INDEX).data(newItemData.name);
      itemsItemTable.api().cell(rowIndex, Constants.ITEMS_ITEM_UNIT_INDEX).data(newItemData.unit);
      itemsItemTable.api().cell(rowIndex, Constants.ITEMS_ITEM_PRICE_INDEX).data(newItemData.price + ' ' + curr);
      itemsItemTable.api().cell(rowIndex, Constants.ITEMS_ITEM_VAT_INDEX).data(newItemData.vat ?? '');
      itemsItemTable.api().cell(rowIndex, Constants.ITEMS_ITEM_CODE_INDEX).data(newItemData.code ?? '');
      itemsItemTable.api().draw(false);

      row.find('.item__price').attr('data-currency', newItemData.currency);
      handleDifferentCurrencyInputs()

      closeModal($('form#editItem').closest('.modal'));
      emptyForm(form);

      reloadItemsTable();
      toastAlert('Pomyślnie edytowano artykuł');
    }, null, err => console.log(err))

    // Edycja zwierzyny
    $('#editAnimal [name="animal_intended_use_id"]').change(function () {
      let form = $(this).closest('form');

      if (parseInt($(this).val()) === 1) {
        showField(form, 'collection_centre_id');
        showField(form, 'number_mp');
      } else {
        hideField(form, 'collection_centre_id');
        hideField(form, 'number_mp')
      }
    })

    const openEditAnimalModal = (id, type) => {
      let animal = dataLayer.state.animals.find(el => parseInt(el.id) === parseInt(id) && el.type === type);

      if (!animal) {
        return;
      }

      currentlyEditedAnimal = animal;

      let form = $('form#editAnimal');

      showField(form, 'weight');


      // if (parseInt(animal.is_big) === 0) {
      //   hideField(form, 'weight');
      // } else {
      //   showField(form, 'weight');
      // }

      openModal(form.closest('.modal'));
      fillFormInputs(form, {
        animal: animal.name,
        weight: animal.weight,
        identifier: animal.identifier,
        identifier_district_veterinarian: animal.identifier_district_veterinarian,
        identifier_direct_sale: animal.identifier_direct_sale,
        animal_intended_use_id: animal.intended_use,
        collection_centre_id: animal.collection_centre_id,
        number_mp: animal.number_mp,
        id: animal.id,
        type: animal.type
      })

      form.find('[name="animal_intended_use_id"]').trigger('change');
    }

    let currentlyEditedAnimal = null;
    body.on('click', '.btnEditAnimal', function () {
      let id = $(this).data('id');
      let type = $(this).data('type');

      updateAnimalQuantityAfterModalEdit = false
      openEditAnimalModal(id, type)
    })

    handleApiForm($('form#editAnimal'), ({response, form}) => {
      let animal = response.data.animal;

      if (animal.collection_centre_id) {
        const collectionCentreOption = collectionCentreNode.find(`option[value="${animal.collection_centre_id}"]`);
        if (collectionCentreOption.length) {
          animal.collection_centre = collectionCentreOption.text().trim();
        }
      } else {
        animal.collection_centre = null;
      }

      dataLayer.updateAnimal(animal, el => parseInt(el.id) === parseInt(currentlyEditedAnimal.id) && el.type === currentlyEditedAnimal.type);

      reloadAnimalsTable();

      closeModal(form.closest('.modal'));

      if(updateAnimalQuantityAfterModalEdit) {
        const invoiceItem = dataLayer.state.invoiceItems.find(i => i.id === currentlyEditedAnimal.id && i.type === currentlyEditedAnimal.type);

        if(invoiceItem) {
          invoiceItem.weight = animal.weight;
          invoiceItem.quantity = animal.quantity;
        }
      }

      updateCarcassesLeft();
      reloadItemsTable();
      toastAlert('Pomyślnie edytowano zwierzynę');
    });

    body.on('click', '[data-app-action="edit_quantity"]', function() {
      const uniqueId = $(this).closest('tr').attr('data-app-unique_id')
      const item = dataLayer.getInvoiceItem(uniqueId)

      if(!item.isAnimal) {
        return
      }

      updateAnimalQuantityAfterModalEdit = true
      openEditAnimalModal(item.id, item.type)
    })

    body.on('change', '[data-app-input="quantity"], [data-app-input="vat"]', function() {
      const uniqueId = $(this).closest('tr').attr('data-app-unique_id')
      const item = dataLayer.getInvoiceItem(uniqueId)

      const type = $(this).attr('data-app-input')

      if(item.isAnimal) {
        return
      }

      item[type] = parseFloat($(this).val())
      reloadItemsTable()
    })

    body.on('change', '[data-app-input="price"]', function() {
      const uniqueId = $(this).closest('tr').attr('data-app-unique_id')
      /** @type {InvoiceItem} */
      const item = dataLayer.getInvoiceItem(uniqueId)

      let currentPriceType = 'flat_rate';
      if(parseInt(priceListType) === Constants.PRICE_LIST_REGULAR && item.isAnimal) {
        if(parseInt(item.quality) === 1) {
          currentPriceType = 'price_1_class';
        } else if(parseInt(item.quality) === 2) {
          currentPriceType = 'price_2_class';
        } else {
          currentPriceType = 'price_beyond';
        }
      }

      item[currentPriceType] = parseFloat($(this).val())

      reloadItemsTable()
    })

    body.on('change', '[data-app-input="price_brutto"]', function() {
      const uniqueId = $(this).closest('tr').attr('data-app-unique_id')
      /** @type {InvoiceItem} */
      const item = dataLayer.getInvoiceItem(uniqueId)

      let currentPriceType = 'flat_rate';
      item[currentPriceType] = parseFloat($(this).val())


      reloadItemsTable()
    })

    userNode.change(async function () {
      let result = true;

      let value = $(this).val();
      if (
        (value.startsWith('entity-')) ||
        (!value.startsWith('entity-') && userId.startsWith('entity-'))
      ) {
        result = await confirmModalCheckDisabledItems('Zmiana rodzaju nabywcy spowoduje usunięcie niektórych pozycji. Czy jesteś pewny/a, że chcesz kontynuować?');
      }

      if (result) {
        userId = $(this).val();
        reloadAnimalsTable();
        reloadItemsTable();
      } else {
        $(this).val(userId);
      }

      userChanged = true;
    })

    async function confirmModalCheckDisabledItems(message, modalOptions = {}) {
      let result = true;

      let disabledItems = dataLayer.state.invoiceItems.filter(r => !canItemBeSelected(r).result);
      if (disabledItems.length > 0) {
        result = await confirmModal(message, modalOptions);
        if (result) {
          dataLayer.state.invoiceItems = dataLayer.state.invoiceItems.filter(r => disabledItems.findIndex(d => parseInt(d.id) === parseInt(r.id) && d.type === r.type) === -1);
        }
      }

      return result;
    }

    async function onEntitiesDataUpdated() {
      reloadAnimalsTable();
      await confirmModalCheckDisabledItems('Cennik podmiotu uległ zmianie, niektóre wybrane pozycje zostaną usunięte', {
        buttons: [
          {
            text: 'Ok',
            color: 'warning',
            type: 'resolve'
          },
        ]
      })
      reloadItemsTable();
    }

    let invoiceNumberInput = $('#addInvoice_number, #addInvoiceCorrection_number');
    let startingIndexInput = $('#addInvoice_starting_index, #addInvoiceCorrection_starting_index');
    let currentInvoicesCount = parseInt(window._currentInvoicesCount) ?? 0;
    let season_addon = window._season_addon ?? '';
    let numbering_mode_1 = $('#addInvoice_numbering_mode_1, #addInvoiceCorrection_numbering_mode_1');
    let numbering_mode_2 = $('#addInvoice_numbering_mode_2, #addInvoiceCorrection_numbering_mode_2');

    changeInvoiceNumber()
    numbering_mode_1.attr('checked', true);

    numbering_mode_1.change(function () {
      invoiceNumberInput.attr('readonly', true);
      startingIndexInput.parent().parent().show();
      changeInvoiceNumber();
    })

    numbering_mode_2.change(function () {
      invoiceNumberInput.attr('readonly', false);
      startingIndexInput.parent().parent().hide();
    })

    startingIndexInput.change(function () {
      changeInvoiceNumber();
    })

    function changeInvoiceNumber() {

      let new_index;

      if (isNaN(parseInt(startingIndexInput.val()))) {
        startingIndexInput.val(0);
      }
      new_index = currentInvoicesCount + parseInt(startingIndexInput.val());

      if(isCorrecting) {
        invoiceNumberInput.val(new_index + '/' + season_addon + '/K')
      } else {
        invoiceNumberInput.val(new_index + '/' + season_addon)
      }
    }

    $('[data-app-button="update_seller_details"]').on('click', function () {
      const form = $(this).closest('form')

      $(this).closest('div').hide()

      const fields = [
        'seller_name',
        'seller_address',
        'seller_tax_number',
        'seller_account_number'
      ]

      for (const field of fields) {
        const node = form.find(`[data-app-field="${field}"]`)
        const actual = node.attr('data-app-actual')

        node.text(actual)
        form.append(`<input name="${field}" type="hidden" value="${actual}" />`)
      }
    })

    $('[data-app-button="update_buyer_details"]').on('click', function () {
      const form = $(this).closest('form')

      $(this).closest('div').hide()

      const fields = [
        'name',
        'address',
        'tax_number',
      ]

      for (const field of fields) {
        const actual = window.currentBuyerActual ? window.currentBuyerActual[field] : ''

        if (typeof actual == 'undefined') {
          continue
        }

        form.append(`<input name="buyer_${field}" type="hidden" value="${actual}" />`)
      }
    })

    $('[name="type"], [name="collection_centre_id"], [name="user_id"]').on('change', function () {
      if (!window.currentBuyerClass || !window.currentBuyerClass) {
        return;
      }

      const type = parseInt($('[name="type"]').val())

      let className = ''
      let id = null

      switch (type) {
        case 1:
        case 3:
          id = $('[name="user_id"]').val()

          if (id.startsWith('entity-')) {
            id = parseInt(id.replace('entity-', ''))
            className = 'app\\models\\BusinessEntity'
          } else {
            id = parseInt(id)
            className = 'app\\models\\User'
          }
          break;
        case 2:
          id = parseInt($('[name="collection_centre_id"]').val())
          className = 'app\\models\\CollectionCentre'
          break;
        case 4:
          id = parseInt(window.associationId)
          className = 'app\\models\\Association'
          break;
      }

      if (id && className) {
        if (window.currentBuyerClass !== className || window.currentBuyerId !== id) {
          $('[data-app-box="buyer_details_warning"]').hide()
        } else {
          $('[data-app-box="buyer_details_warning"]').show()
        }
      }
    })
  }

  const isAutoGenerated = (number) => {
    const regex = /^[0-9]*\/[0-9]{4}$/;
    return number.match(regex);
  }

  function naturalInvoiceSort(a, b, html) {
    if (isAutoGenerated(a) && isAutoGenerated(b)) {
      let yearA = a.split('/')[1]
      let yearB = b.split('/')[1]

      if (yearA === yearB) {
        return naturalSort(a, b, html);
      }

      return parseInt(yearA) - parseInt(yearB);
    }

    return naturalSort(a, b, html);
  }

  jQuery.extend(jQuery.fn.dataTableExt.oSort, {
    "natural_invoice-asc": function (a, b) {
      return naturalInvoiceSort(a, b, true);
    },

    "natural_invoice-desc": function (a, b) {
      return naturalInvoiceSort(a, b, true) * -1;
    },

    "natural_invoice-nohtml-asc": function (a, b) {
      return naturalInvoiceSort(a, b, false);
    },

    "natural_invoice-nohtml-desc": function (a, b) {
      return naturalInvoiceSort(a, b, false) * -1;
    },

    "natural_invoice-ci-asc": function (a, b) {
      a = a.toString().toLowerCase();
      b = b.toString().toLowerCase();

      return naturalInvoiceSort(a, b, true);
    },

    "natural_invoice-ci-desc": function (a, b) {
      a = a.toString().toLowerCase();
      b = b.toString().toLowerCase();

      return naturalInvoiceSort(a, b, true) * -1;
    }
  });

  if (pathIs('/app/reckonings/invoices')) {
    const body = $('body');
    let invoicesTableNode = $("#invoicesTable");
    let internalExpenditureTableNode = $("#internalExpenditureTable");
    let carcassDisposalTableNode = $("#carcassDisposalTable");
    let correctionsTableNode = $("#correctionsTable");

    let invoicesTable = invoicesTableNode.DataTable({
      stateSave: false,
      order: [0, 'desc'],
      columnDefs: [
        {
          targets: 0,
          'type': 'natural_invoice'
        },
      ],
      drawCallback: function () {
        this.$('.payment-status-tooltip').each(function () {
          new bootstrap.Tooltip(this, {html: true});
        })
      },
      filters: {
        columns: [
          {
            index: 6,
            title: 'Opłacona',
            values: [
              {
                text: 'Tak',
                value: 'Tak',
                custom: (settings, data) => {
                  data = data[6];

                  if (typeof data == 'undefined') {
                    return true;
                  }

                  if (data.includes('Tak')) {
                    return true;
                  }
                }
              },
              {
                text: 'Nie',
                value: 'Nie',
                custom: (settings, data) => {
                  data = data[6];

                  if (typeof data == 'undefined') {
                    return true;
                  }

                  if (data.includes('Nie')) {
                    return true;
                  }
                }
              }]
          }
        ]
      }
    });
    let invoicesTableApi = invoicesTable.api();

    invoicesTableNode.on('responsive-display.dt', function (e, dt, row) {
      $(row.node()).next('.child').find('.payment-status-tooltip').each(function () {
        new bootstrap.Tooltip(this, {html: true});
      })
    })

    let correctionsTable = correctionsTableNode.DataTable({
      stateSave: false,
      order: [0, 'desc'],
      columnDefs: [
        {
          targets: 0,
          'type': 'natural_invoice'
        },
      ],
      drawCallback: function () {
        this.$('.payment-status-tooltip').each(function () {
          new bootstrap.Tooltip(this, {html: true});
        })
      },
      filters: {
        columns: [
          {
            index: 6,
            title: 'Opłacona',
            values: [
              {
                text: 'Tak',
                value: 'Tak',
                custom: (settings, data) => {
                  data = data[6];

                  if (typeof data == 'undefined') {
                    return true;
                  }

                  if (data.includes('Tak')) {
                    return true;
                  }
                }
              },
              {
                text: 'Nie',
                value: 'Nie',
                custom: (settings, data) => {
                  data = data[6];

                  if (typeof data == 'undefined') {
                    return true;
                  }

                  if (data.includes('Nie')) {
                    return true;
                  }
                }
              }]
          }
        ]
      }
    });

    correctionsTableNode.on('responsive-display.dt', function (e, dt, row) {
      $(row.node()).next('.child').find('.payment-status-tooltip').each(function () {
        new bootstrap.Tooltip(this, {html: true});
      })
    })

    let internalExpenditureTable = internalExpenditureTableNode.DataTable({
      stateSave: false,
      order: [0, 'desc'],
      columnDefs: [
        {
          targets: 0,
          'type': 'natural_invoice'
        },
      ],
      drawCallback: function () {
        this.$('.payment-status-tooltip').each(function () {
          new bootstrap.Tooltip(this, {html: true});
        })
      }
    });
    let internalExpenditureTableApi = internalExpenditureTable.api();

    internalExpenditureTableNode.on('responsive-display.dt', function (e, dt, row) {
      $(row.node()).next('.child').find('.payment-status-tooltip').each(function () {
        new bootstrap.Tooltip(this, {html: true});
      })
    })

    $('.payment-status-tooltip').each(function () {
      new bootstrap.Tooltip(this, {html: true});
    })

    let carcassDisposalTable = carcassDisposalTableNode.DataTable({
      stateSave: false,
      order: [0, 'desc'],
      columnDefs: [
        {
          targets: 0,
          'type': 'natural_invoice'
        },
      ],
      drawCallback: function () {
        this.$('.payment-status-tooltip').each(function () {
          new bootstrap.Tooltip(this, {html: true});
        })
      }
    });
    let carcassDisposalTableApi = carcassDisposalTable.api();

    carcassDisposalTableNode.on('responsive-display.dt', function (e, dt, row) {
      $(row.node()).next('.child').find('.payment-status-tooltip').each(function () {
        new bootstrap.Tooltip(this, {html: true});
      })
    })

    $('.payment-status-tooltip').each(function () {
      new bootstrap.Tooltip(this, {html: true});
    })


    const INVOICES_PAYMENT_STATUS_CHANGE_DATE_INDEX = 6;
    const INVOICES_ACTION_INDEX = 7;

    let iframe = $('iframe');

    const setHeight = (iframe, spinner, counter = 0) => {
      let height = iframe.contentWindow.document.body.scrollHeight;

      if (counter > 50) {
        iframe.style.height = 'initial';
        spinner.destroy();
      }

      if (height === 0) {
        setTimeout(() => {
          setHeight(iframe, spinner, counter++)
        }, 50)
      } else {
        iframe.style.height = height + 'px';
        spinner.destroy();
      }
    }


    if (invoicesTable.length > 0) {
      invoicesTable.on('check-all.changed', function (e, any) {
        $("#btnInvoicesSelectedToPdf").attr('disabled', !any);
      })

      // Generowanie wydruku zbiorowego
      $("#btnInvoicesSelectedToPdf").click(async function (e) {
        e.preventDefault();

        let spinner = new Spinner(null, 'Trwa generowanie wydruku zbiorowego');

        try {
          let ids = '?';
          let i = 0;
          for (let input of invoicesTable.DataTable().api().checkedCheckboxes()) {

            if (i !== 0) {
              ids += '&';
            }

            ids += "ids[]=" + $(input).val();
            i++;
          }

          let response = await axios.get(`${url('app/reckonings/invoices/group-pdf')}${ids}`, {
            responseType: 'blob'
          });
          spinner.destroy();

          FileDownload(response.data, 'Faktury.pdf');

        } catch (err) {
          console.log(err)
        }
      })
    }

    body.on('click', '.btnDetails', async function () {
      let modalNode = $("#detailsModal");
      let modalInstance = bootstrap.Modal.getInstance(modalNode[0]) ?? new bootstrap.Modal(modalNode[0]);
      let id = $(this).data('id');
      let number = $(this).data('number');
      let rw = $(this).data('rw');
      let cd = $(this).data('cd');

      let spinner = new Spinner();
      iframe.height(0);

      if (rw == 1) {
        modalNode.find('.number').text("Rozchód wewnętrzny " + number);
      }else if(cd == 1) {
        modalNode.find('.number').text("Przekazanie tuszy " + number);
      }else {
        modalNode.find('.number').text("Faktura " + number);
      }

      iframe[0].src = url(`app/reckonings/invoices/${id}`);

      iframe.on('load', function () {
        setHeight(this, spinner);
        iframe.off('load');
      })

      modalInstance.show();
    })

    body.on('click', '.btnChangePaymentStatus', async function () {
      let id = $(this).data('id');
      let row = $(this).closest('tr');
      if (row.hasClass('child')) {
        row = row.prev('tr');
      }

      const isCorrection = typeof $(this).attr('data-app-correction') != 'undefined'
      const tableApi = isCorrection ? correctionsTable.api() : invoicesTable.api();
      const paymentStatusIndex = isCorrection ? INVOICES_PAYMENT_STATUS_CHANGE_DATE_INDEX : INVOICES_PAYMENT_STATUS_CHANGE_DATE_INDEX
      const actionIndex = isCorrection ? INVOICES_ACTION_INDEX : INVOICES_ACTION_INDEX

      let spinner = new Spinner();
      try {

        let response = await axios.post(url(`api/reckonings/invoices/${id}/change-payment-status`));
        if (response.status !== 200) {
          throw new Error();
        }

        let rowIndex = tableApi.row(row).index();
        let cell = tableApi.cell(rowIndex, paymentStatusIndex);

        let actionCell = tableApi.cell(rowIndex, actionIndex).node();

        let date = response.data.payment_status_change_date;
        if (date) {
          $(actionCell).find('.btnChangePaymentStatus').removeClass('btn-primary');
          $(actionCell).find('.btnChangePaymentStatus').addClass('btn-secondary');

          let span = $(cell.data());
          span.text('Tak');
          span.attr('title', `Data zmiany statusu:<br />${moment(date).formatPHP('d/m/Y H:i')}`);

          cell.data(span.prop('outerHTML'));
        } else {
          $(actionCell).find('.btnChangePaymentStatus').removeClass('btn-secondary');
          $(actionCell).find('.btnChangePaymentStatus').addClass('btn-primary');

          let span = $(cell.data());
          span.text('Nie');
          span.attr('title', '');
          span.attr('data-bs-original-title', '');

          cell.data(span.prop('outerHTML'));
        }

        tableApi.cell(rowIndex, actionIndex).data(actionCell[0]);
        tableApi.rows().invalidate();

        tableApi.rows().draw(false);
        spinner.destroy();

        toastAlert('Pomyślnie zmieniono status płatności');
      } catch (err) {
        toastAlert('Nie udało się zmienić statusu płatności', {type: 'danger'})
        spinner.destroy();
      }
    })

    body.on('click', '.btnPreviewEmails', function () {
      let data = $(this).data('emails');
      let modal = $('#emailsModal');
      let modalBody = modal.find('.modal-body');

      let table = $(`
                <table class="table table-striped table-hover">
                    <thead>
                    <tr>
                        <th>Data wysłania</th>
                        <th>Data pobrania faktury</th>
                        <th>Status</th>
                        <th>Odbiorca</th>
                        <th>Akcja</th>
                    </tr>
                    </thead>
                </table>
            `)

      let tbody = $(`<tbody></tbody>`);
      table.append(tbody);

      for (let email of data) {
        let row = $(`<tr></tr>`);
        let status = '';
        switch (parseInt(email.status)) {
          case 1:
            status = 'w kolejce';
            break;
          case 2:
            status = 'wysłana';
            break;
          case 3:
            status = 'błąd';
            break;
        }

        row.append(`<td>${moment(email.created_at).formatPHP('d/m/Y H:i:s')}</td>`)
        row.append(`<td>${email.pdf_download_date ? moment(email.pdf_download_date).formatPHP('d/m/Y H:i:s') : '-'}</td>`)
        row.append(`<td>${status}</td>`)
        row.append(`<td>${email.email} ${email.name ? `(${email.name})` : ''}</td>`)
        if (email.pdf_filename) {
          row.append(`
                        <td>
                            <a target="_blank" class="btn btn-primary btn-sm mb-1" href="${url(`app/reckonings/invoices/${email.invoice_id}/emails/${email.id}`)}">Podgląd</a>
                            <button class="btn btn-danger btn-sm mb-1 btnDeleteInvoiceEmail" data-id="${email.invoice_id}" data-email_id="${email.id}">Usuń</button>
                        </td>
                    `)
        } else {
          row.append(`<td>-</td>`)
        }

        tbody.append(row);
      }

      table.DataTable();
      modalBody.html(table);
      openModal(modal);
    })

    body.on('click', '.btnSendInvoiceCustom', function () {
      let modal = $('#sendInvoiceCustomModal');
      let form = modal.find('form');

      form.attr('action', url(`app/reckonings/invoices/${$(this).data('id')}/send`));

      form.find('input[name="name"]').val($(this).data('name'));
      form.find('input[name="email"]').val($(this).data('email'));

      openModal(modal);
    })

    body.on('click', '.btnDeleteInvoiceEmail', async function () {
      if (await confirmModal('Czy na pewno chcesz usunąć wysłaną fakturę? Usunięty zostanie jedynie plik z fakturą. Wiadomość pozostanie w skrzynce odbiorcy.', {color: 'danger'})) {
        let form = $("#deleteInvoiceEmailForm");
        form.attr('action', url(`app/reckonings/invoices/${$(this).data('id')}/emails/${$(this).data('email_id')}/delete`));
        form.submit();
      }
    })

  }
}
